export default "__VITE_ASSET__4d87a8bd__"